(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  if ('ResizeObserver' in window) {
    const root = document.documentElement;
    let observed;
    const observer = new ResizeObserver(() => measure());

    // Vue replaces the header node when it mounts, so the element is looked up on every pass.
    function measure() {
      const header = document.querySelector('header');
      const height = header ? header.getBoundingClientRect().height : 0;

      if (header && header !== observed) {
        if (observed) observer.unobserve(observed);
        observer.observe(header);
        observed = header;
      }
      if (height) root.style.setProperty('--header-h', `${height}px`);
    }

    observer.observe(root);
    measure();
  }

  // The location toggle's open state is a class the menu script flips; mirror it for assistive tech.
  // Vue replaces the pickers when it mounts (F-149), so the document is observed and the pickers re-found each time.
  const reflect = () => document.querySelectorAll('.location-picker').forEach((picker) => {
    const toggle = picker.querySelector('.location-picker__active');
    if (toggle) toggle.setAttribute('aria-expanded', String(!picker.classList.contains('closed')));
  });

  new MutationObserver(reflect).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class'] });
  reflect();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-best-sellers')) {
    customElements.define('hp-best-sellers', class extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        this.tabs = [...this.querySelectorAll('.hp-bsl__tab')];
        if (!this.tabs.length) return;
        this.list = this.querySelector('.hp-bsl__tabs');
        this.controls = this.querySelector('.hp-bsl__controls');
        this.panels = [...this.querySelectorAll('.hp-bsl__panel')];
        this.index = Math.max(0, this.panels.findIndex((p) => !p.hidden));
        const opts = { signal: this.ac.signal };
        this.addEventListener('click', (e) => {
          const tab = e.target.closest('.hp-bsl__tab');
          if (tab) return this.show(this.tabs.indexOf(tab));
          const arrow = e.target.closest('[data-bsl-scroll]');
          if (arrow && !arrow.disabled) this.scrollProducts(Number(arrow.dataset.bslScroll));
        }, opts);
        this.addEventListener('keydown', (e) => {
          if (!e.target.closest('.hp-bsl__tab')) return;
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          const jump = { Home: 0, End: this.tabs.length - 1 }[e.key];
          if (step) { e.preventDefault(); this.show(this.index + step, true); }
          else if (jump !== undefined) { e.preventDefault(); this.show(jump, true); }
        }, opts);
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.findIndex((t) => t.contains(e.target));
          if (i > -1) this.show(i);
        }, opts);
        this.row = matchMedia('(max-width: 768px)');
        this.row.addEventListener('change', () => this.paint(), opts);
        this.addEventListener('scroll', (e) => {
          if (e.target === this.activeRow) this.updateControls();
        }, { ...opts, capture: true, passive: true });
        window.addEventListener('resize', () => this.updateControls(), opts);
        if ('ResizeObserver' in window) this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.hover = matchMedia('(hover: hover) and (pointer: fine)');
        this.hover.addEventListener('change', () => this.prepareMedia(), opts);
        this.addEventListener('pointerover', (e) => {
          if (e.pointerType === 'touch') return;
          this.prepareHover(e.target.closest('.hp-bsl__card'));
        }, opts);
        this.addEventListener('focusin', (e) => {
          const card = e.target.closest('.hp-bsl__card');
          this.prepareHover(card);
          if (!card || this.row.matches || !this.activeRow?.contains(card) || !e.target.matches(':focus-visible')) return;
          const bounds = this.activeRow.getBoundingClientRect();
          const cardBounds = card.getBoundingClientRect();
          const left = Math.max(bounds.left, 0);
          const right = Math.min(bounds.right, innerWidth);
          if (right <= left) return;
          const delta = cardBounds.left < left ? cardBounds.left - left : cardBounds.right > right ? cardBounds.right - right : 0;
          if (delta) this.activeRow.scrollBy({ left: delta, behavior: 'instant' });
        }, opts);
        if ('IntersectionObserver' in window) {
          this.sectionObserver = new IntersectionObserver((entries) => {
            this.mediaNear = entries.some((entry) => entry.isIntersecting);
            this.prepareMedia();
          }, { rootMargin: '800px 0px' });
          this.sectionObserver.observe(this);
        } else this.mediaNear = true;
        this.paint();
      }
      disconnectedCallback() {
        this.ac.abort();
        this.sectionObserver?.disconnect();
        this.cardObserver?.disconnect();
        this.resizeObserver?.disconnect();
      }
      scrollProducts(step) {
        const row = this.activeRow;
        if (!row || this.row.matches) return;
        const direction = getComputedStyle(row).direction === 'rtl' ? -1 : 1;
        row.scrollBy({ left: direction * step * row.clientWidth * 0.85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      updateControls() {
        const row = this.activeRow;
        if (!this.controls || !row) return;
        const max = row.scrollWidth - row.clientWidth;
        const position = Math.abs(row.scrollLeft);
        this.controls.hidden = this.row.matches || max <= 1;
        this.controls.querySelectorAll('[data-bsl-scroll]').forEach((button) => {
          button.setAttribute('aria-controls', row.id);
          button.disabled = this.controls.hidden || (Number(button.dataset.bslScroll) < 0 ? position <= 1 : position >= max - 1);
        });
      }
      prepareHover(card) {
        const deferred = card?.querySelector('template[data-hp-hover]');
        if (!deferred) return;
        const image = deferred.content.querySelector('img');
        if (image) {
          image.fetchPriority = 'auto';
          image.loading = 'eager';
        }
        deferred.replaceWith(deferred.content);
      }
      prepareMedia() {
        this.cardObserver?.disconnect();
        if (!this.mediaNear) return;
        const panel = this.panels[this.index];
        const row = panel?.querySelector('.hp-bsl__cards');
        if (!row) return;
        const prepare = (card) => {
          const image = card.querySelector('.hp-bsl__img:not(.hp-bsl__img--hover)');
          if (image) {
            image.fetchPriority = 'auto';
            image.loading = 'eager';
          }
          if (this.hover.matches) this.prepareHover(card);
        };
        const cards = row.querySelectorAll('.hp-bsl__card');
        if ('IntersectionObserver' in window) {
          this.cardObserver = new IntersectionObserver((entries) => {
            entries.filter((entry) => entry.isIntersecting).forEach((entry) => prepare(entry.target));
          }, { root: row, rootMargin: '0px 100%' });
          cards.forEach((card) => this.cardObserver.observe(card));
        } else cards.forEach(prepare);
      }
      show(i, focus) {
        const n = this.panels.length;
        this.index = (i + n) % n;
        this.paint();
        if (focus) this.tabs[this.index].focus();
      }
      paint() {
        this.tabs.forEach((t, k) => { const on = k === this.index; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        this.panels.forEach((p, k) => {
          p.hidden = k !== this.index;
          const deferred = p.hidden ? null : p.querySelector(':scope > template');
          if (deferred) deferred.replaceWith(...deferred.content.childNodes, ...deferred.childNodes);
        });
        this.list.setAttribute('aria-orientation', this.row.matches ? 'horizontal' : 'vertical');
        this.activeRow = this.panels[this.index]?.querySelector('.hp-bsl__cards');
        this.resizeObserver?.disconnect();
        if (this.activeRow) this.resizeObserver?.observe(this.activeRow);
        this.updateControls();
        this.prepareMedia();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hall-of-fame"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-hall-of-fame')) {
    customElements.define('hp-hall-of-fame', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.ac = new AbortController();
        const opts = { signal: this.ac.signal };
        const heading = this.querySelector('.hp-hof__heading');
        if (heading) {
          const travel = () => window.hpCurveTravel(this, heading, {
            signal: this.ac.signal,
            sourceOffset: (mobile) => (mobile ? 25.98716314 : 25),
            onMove: ({ text, mobile, last }) => {
              if (!heading.querySelector('.hp-curved-title__bunny')) return;
              const matrix = text.getScreenCTM();
              if (!matrix) return;
              const end = text.getEndPositionOfChar(last);
              const point = new DOMPoint(end.x, end.y).matrixTransform(matrix);
              const headingBounds = heading.getBoundingClientRect();
              const scale = this.clientWidth / (mobile ? 388.0238647 : 1417.1868896);
              heading.style.setProperty('--hp-bunny-x', (point.x - headingBounds.x + 8 * scale) + 'px');
              heading.style.setProperty('--hp-bunny-y', (point.y - headingBounds.y - 85 * scale) + 'px');
            }
          });
          // The snippet bundle that defines the helper can run after this element upgrades.
          if (window.hpCurveTravel) travel();
          else document.addEventListener('DOMContentLoaded', travel, { once: true, ...opts });
        }
        this.querySelectorAll('[data-video-player]').forEach((player) => {
          const video = player.querySelector('video');
          const button = player.querySelector('[data-video-toggle]');
          if (!video || !button) return;
          video.controls = false;
          button.hidden = false;
          const update = () => {
            const playing = !video.paused && !video.ended;
            player.classList.toggle('is-playing', playing);
            button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
          };
          button.addEventListener('click', () => {
            if (video.paused) video.play().catch(() => { video.controls = true; button.hidden = true; update(); });
            else video.pause();
          }, opts);
          video.addEventListener('error', () => { video.controls = true; button.hidden = true; }, opts);
          ['play', 'pause', 'ended'].forEach((event) => video.addEventListener(event, update, opts));
          update();
          this.ac.signal.addEventListener('abort', () => video.pause());
        });
        const buttons = [...this.querySelectorAll('.hp-hof__marker-btn')];
        const toggle = (btn, open, pinned) => {
          if (!btn) return;
          const pop = this.querySelector('#' + btn.getAttribute('aria-controls'));
          if (open) {
            const marker = btn.closest('.hp-hof__marker');
            const bounds = marker.getBoundingClientRect();
            marker.classList.toggle('hp-hof__marker--end', bounds.left + bounds.width / 2 > innerWidth / 2);
          }
          btn.setAttribute('aria-expanded', String(open));
          btn.toggleAttribute('data-pinned', Boolean(open && pinned));
          if (pop) pop.hidden = !open;
        };
        const closeAll = (except) => buttons.forEach((b) => { if (b !== except && b.getAttribute('aria-expanded') === 'true') toggle(b, false); });
        const groups = [...this.querySelectorAll('[data-hof-year]')];
        const navigation = this.querySelector('[data-years]');
        const controls = this.querySelector('.hp-hof__year-controls');
        const previousId = this.activeYearId;
        const years = groups.map((group) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hp-hof__year';
          button.dataset.year = group.id;
          button.textContent = group.dataset.hofYear;
          button.setAttribute('aria-controls', group.id);
          return button;
        });
        navigation.replaceChildren(...years);
        navigation.hidden = !years.length;
        controls.hidden = years.length < 2;
        controls.querySelectorAll('button').forEach((button) => { button.disabled = years.length < 2; });
        let current = 0;
        const select = (index, announce = true) => {
          if (!years.length) return;
          closeAll();
          current = (index + years.length) % years.length;
          this.activeYearId = groups[current].id;
          years.forEach((button, i) => {
            button.classList.toggle('is-active', i === current);
            button.setAttribute('aria-pressed', String(i === current));
            groups[i].hidden = i !== current;
            if (groups[i].hidden) groups[i].querySelectorAll('video').forEach((video) => video.pause());
          });
          if (announce) this.querySelector('[data-status]').textContent = years[current].textContent;
        };
        select(Math.max(0, groups.findIndex((group) => group.id === previousId)), false);
        this.classList.add('is-enhanced');
        // Selection bubbles from nested media/markers to their owning Year.
        this.addEventListener('shopify:block:select', (event) => {
          const group = event.target.closest('[data-hof-year]');
          const index = groups.indexOf(group);
          if (index !== -1) select(index, false);
        }, opts);
        // A mouse opens on enter and closes on leave (WCAG 1.4.13); a click pins the note open, a second click closes it.
        // Touch and keyboard have only the click.
        this.addEventListener('click', (e) => {
          const step = e.target.closest('[data-step]');
          const year = e.target.closest('[data-year]');
          if (step) select(current + Number(step.dataset.step));
          if (year) select(years.indexOf(year));
          const btn = e.target.closest('.hp-hof__marker-btn');
          if (!btn) return;
          closeAll(btn);
          const pinned = btn.hasAttribute('data-pinned');
          toggle(btn, !pinned, true);
        }, opts);
        buttons.forEach((btn) => {
          const marker = btn.closest('.hp-hof__marker');
          marker.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches && btn.getAttribute('aria-expanded') !== 'true') { closeAll(btn); toggle(btn, true, false); } }, opts);
          marker.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches && !btn.hasAttribute('data-pinned') && !marker.contains(document.activeElement)) toggle(btn, false); }, opts);
          btn.addEventListener('focus', () => { closeAll(btn); toggle(btn, true, false); }, opts);
        });
        this.addEventListener('keydown', (e) => {
          if (!e.target.closest('[data-years], .hp-hof__year-controls')) return;
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          select(current + (e.key === 'ArrowRight' ? 1 : -1));
          if (e.target.closest('[data-years]')) years[current].focus();
        }, opts);
        const io = new IntersectionObserver((entries) => {
          const inView = entries.some((entry) => entry.isIntersecting);
          this.classList.toggle('is-in-view', inView);
          this.toggleAttribute('data-hp-motion-out-of-view', !inView);
        }, { threshold: 0.1 });
        io.observe(this);
        this.ac.signal.addEventListener('abort', () => io.disconnect());
        const blockObserver = new MutationObserver((records) => {
          const changed = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
            node.nodeType === 1 && (node.matches?.('.hp-hof__group, .hp-hof__item, .hp-hof__marker') || node.querySelector?.('.hp-hof__group, .hp-hof__item, .hp-hof__marker'))
          ));
          if (changed && this.isConnected) this.connectedCallback();
        });
        blockObserver.observe(this.querySelector('.hp-hof__stage'), { childList: true, subtree: true });
        this.ac.signal.addEventListener('abort', () => blockObserver.disconnect());
        this.addEventListener('focusout', (e) => { const m = e.target.closest('.hp-hof__marker'); if (m && !m.contains(e.relatedTarget)) toggle(m.querySelector('.hp-hof__marker-btn'), false); }, opts);
        document.addEventListener('pointerdown', (e) => { if (!e.target.closest('.hp-hof__marker')) closeAll(); }, opts);
        document.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          const open = buttons.find((b) => b.getAttribute('aria-expanded') === 'true');
          if (!open) return;
          open.focus();
          closeAll();
        }, opts);
      }
      disconnectedCallback() { this.ac?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-hero-video')) {
    customElements.define('hp-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        const video = this.querySelector('video');
        const button = this.querySelector('.hp-hero__play');
        if (!video || !button) return;
        this.ac = new AbortController();
        const opts = { signal: this.ac.signal };
        const playLabel = button.getAttribute('aria-label');
        video.controls = false;
        button.hidden = false;
        const sync = () => {
          this.toggleAttribute('data-playing', !video.paused);
          button.setAttribute('aria-label', video.paused ? playLabel : this.dataset.pauseLabel || playLabel);
        };
        button.addEventListener('click', () => (video.paused ? video.play().catch(sync) : video.pause()), opts);
        ['play', 'pause', 'ended'].forEach((type) => video.addEventListener(type, sync, opts));
        sync();
      }
      disconnectedCallback() { this.ac?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-join-sneak"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-join-sneak')) {
    customElements.define('hp-join-sneak', class extends HTMLElement {
      connectedCallback() {
        // The form posts to /contact#<form id>; a document with a fragment drops its autofocus candidates, so focus by hand.
        this.querySelector('[autofocus]')?.focus();
        this.ac = new AbortController();
        this.animationTemplate = this.querySelector('template[data-hp-animation]');
        this.still ||= this.querySelector('.hp-js__media');
        this.waitingForStill = false;
        this.stillSettled = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.restoreStill();
          else if (this.near) this.prepareMedia();
        }, { signal: this.ac.signal });
        if (this.motion.matches) this.restoreStill();
        if ('IntersectionObserver' in window) {
          this.mediaObserver = new IntersectionObserver((entries) => {
            this.near = entries.some((entry) => entry.isIntersecting);
            if (this.near) this.prepareMedia();
          }, { rootMargin: '800px 0px' });
          this.mediaObserver.observe(this);
        } else {
          this.near = true;
          this.prepareMedia();
        }
      }
      prepareMedia() {
        if (this.still) {
          this.still.fetchPriority = this.animationTemplate ? 'high' : 'auto';
          this.still.loading = 'eager';
        }
        if (!this.animationTemplate || this.animation || this.motion.matches) return;
        if (this.still && !this.still.complete && !this.stillSettled) {
          if (!this.waitingForStill) {
            this.waitingForStill = true;
            const resume = () => {
              this.waitingForStill = false;
              this.stillSettled = true;
              if (this.isConnected && this.near) this.prepareMedia();
            };
            const options = { once: true, signal: this.ac.signal };
            this.still.addEventListener('load', resume, options);
            this.still.addEventListener('error', resume, options);
          }
          return;
        }
        const source = this.animationTemplate.content.querySelector('img');
        if (!source) return;
        const animation = document.createElement('img');
        this.animation = animation;
        animation.addEventListener('load', () => {
          if (this.isConnected && !this.motion.matches && this.animation === animation) this.still.replaceWith(animation);
        }, { once: true, signal: this.ac.signal });
        animation.addEventListener('error', () => {
          if (this.animation === animation) this.animation = null;
        }, { once: true, signal: this.ac.signal });
        for (const attr of source.attributes) animation.setAttribute(attr.name, attr.value);
        animation.fetchPriority = 'auto';
        animation.loading = 'eager';
      }
      restoreStill() {
        if (!this.animation) return;
        this.animation.replaceWith(this.still);
        this.animation.removeAttribute('srcset');
        this.animation.removeAttribute('src');
        this.animation = null;
      }
      disconnectedCallback() {
        this.ac?.abort();
        this.mediaObserver?.disconnect();
        this.restoreStill();
        this.near = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-product-highlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-product-highlight')) {
    customElements.define('hp-product-highlight', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.ro?.disconnect();
        this.mo?.disconnect();
        this.sceneIO?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = 0;
        this.needsRebuild = false;
        this.animations?.forEach((animation) => animation.cancel());
        this.ac = new AbortController();
        this.sceneIO = new IntersectionObserver((entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          this.toggleAttribute('data-hp-motion-out-of-view', !visible);
          if (visible && this.dataset.categoryTransition === 'swap') {
            this.querySelectorAll('.hp-ph__img-media[loading="lazy"]').forEach((image) => { image.loading = 'eager'; });
          }
        });
        this.sceneIO.observe(this);
        this.list = this.querySelector('.hp-ph__tabs');
        this.stage = this.querySelector('.hp-ph__stage');
        if (!this.list || !this.stage) return;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.row = matchMedia('(max-width: 768px)');
        this.animations = [];
        this.refresh();
        const opts = { signal: this.ac.signal };
        this.row.addEventListener('change', () => this.paint(), opts);
        this.reduced.addEventListener('change', () => {
          if (!this.reduced.matches) return;
          this.transition = (this.transition || 0) + 1;
          this.animations.forEach((animation) => animation.cancel());
          this.paint();
        }, opts);
        this.addEventListener('click', (e) => {
          const tab = e.target.closest('.hp-ph__tab');
          if (tab) return this.show(this.tabs.indexOf(tab));
          const arrow = e.target.closest('.hp-ph__arrow');
          if (arrow && this.panels.length) this.show(this.index + Number(arrow.dataset.step));
        }, opts);
        this.addEventListener('keydown', (e) => {
          if (!e.target.closest('.hp-ph__tab')) return;
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
          const jump = { Home: 0, End: this.tabs.length - 1 }[e.key];
          if (step) { e.preventDefault(); this.show(this.index + step, true); }
          else if (jump !== undefined) { e.preventDefault(); this.show(jump, true); }
        }, opts);
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.panels.findIndex((p) => p.contains(e.target));
          if (i > -1) this.show(i);
        }, opts);
        this.stage.addEventListener('pointerdown', (e) => {
          if (e.target.closest('a, button')) return;
          this.pointer = { x: e.clientX, y: e.clientY, id: e.pointerId };
        }, opts);
        this.stage.addEventListener('pointerup', (e) => {
          const start = this.pointer;
          this.pointer = null;
          if (!start || start.id !== e.pointerId) return;
          const dx = e.clientX - start.x;
          const dy = e.clientY - start.y;
          if (this.panels.length > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
        }, opts);
        this.stage.addEventListener('pointercancel', () => { this.pointer = null; }, opts);
        this.ro = new ResizeObserver(() => {
          if (this.width === this.clientWidth) return;
          this.width = this.clientWidth;
          this.reserveHeight();
        });
        this.ro.observe(this);
        // The editor can replace, reorder or rename a nested block without a full reload.
        this.mo = new MutationObserver((records) => {
          const rebuild = records.some((record) => record.type === 'attributes' ||
            [...record.addedNodes, ...record.removedNodes].some((node) =>
              node.nodeType === 1 && (node.matches('.hp-ph__panel') || node.querySelector('.hp-ph__panel'))
            ));
          this.scheduleRefresh(rebuild);
        });
        this.mo.observe(this.stage, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-category-title'] });
        this.paint();
        this.reserveHeight();
        document.fonts.ready.then(() => { if (this.isConnected && !opts.signal.aborted) this.scheduleRefresh(); });
        this.stage.addEventListener('load', () => this.scheduleRefresh(), { capture: true, signal: this.ac.signal });
      }
      disconnectedCallback() {
        this.sceneIO?.disconnect();
        this.ac?.abort();
        this.ro?.disconnect();
        this.mo?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = 0;
        this.needsRebuild = false;
        this.transition = (this.transition || 0) + 1;
        this.animations?.forEach((a) => a.cancel());
      }
      scheduleRefresh(rebuild = false) {
        this.needsRebuild = this.needsRebuild || rebuild;
        if (this.refreshFrame) return;
        this.refreshFrame = requestAnimationFrame(() => {
          this.refreshFrame = 0;
          if (!this.isConnected || this.ac.signal.aborted) return;
          const rebuild = this.needsRebuild;
          this.needsRebuild = false;
          if (rebuild) this.refresh();
          else this.reserveHeight();
        });
      }
      refresh() {
        this.animations.forEach((a) => a.cancel());
        this.transition = (this.transition || 0) + 1;
        const selected = this.dataset.activeCategory;
        this.panels = [...this.stage.querySelectorAll(':scope > .hp-ph__panel')];
        this.tabs = this.panels.map((panel) => {
          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'hp-btn hp-ph__tab';
          tab.id = `${panel.id}-tab`;
          tab.textContent = panel.dataset.categoryTitle;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          return tab;
        });
        this.list.replaceChildren(...this.tabs);
        this.list.setAttribute('role', 'tablist');
        this.list.hidden = !this.panels.length;
        this.querySelector('.hp-ph__progress').hidden = this.panels.length < 2;
        this.querySelectorAll('.hp-ph__arrow').forEach((arrow) => { arrow.hidden = this.panels.length < 2; });
        this.index = Math.max(0, this.panels.findIndex((panel) => panel.dataset.categoryId === selected));
        this.dataset.enhanced = 'true';
        this.paint();
        this.reserveHeight();
      }
      reserveHeight() {
        const states = this.panels.map((panel) => ({ hidden: panel.hidden, visibility: panel.style.visibility }));
        this.stage.style.minBlockSize = '';
        this.panels.forEach((panel) => { panel.style.visibility = 'hidden'; panel.hidden = false; });
        const height = this.stage.getBoundingClientRect().height;
        this.panels.forEach((panel, i) => { panel.hidden = states[i].hidden; panel.style.visibility = states[i].visibility; });
        this.stage.style.minBlockSize = `${height}px`;
      }
      async show(i, focus) {
        const n = this.panels.length;
        if (!n) return;
        const next = (i + n) % n;
        if (next === this.index) return;
        const previous = this.panels[this.index];
        const height = this.stage.getBoundingClientRect().height;
        const direction = i > this.index ? 1 : -1;
        this.animations.forEach((a) => a.cancel());
        const token = this.transition = (this.transition || 0) + 1;
        this.index = next;
        this.paint();
        if (focus) this.tabs[this.index].focus();
        this.tabs[this.index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        this.stage.style.minBlockSize = `${Math.max(height, this.stage.getBoundingClientRect().height)}px`;
        const incoming = this.panels[this.index];
        [previous, incoming].forEach((panel) => {
          panel.querySelectorAll('[data-hp-reveal]').forEach((target) => target.classList.remove('is-hp-armed'));
        });
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
        previous.hidden = false;
        previous.inert = true;
        previous.setAttribute('aria-hidden', 'true');
        const swap = this.dataset.categoryTransition === 'swap';
        previous.toggleAttribute('data-exiting', swap);
        const outgoingCopy = swap ? previous.querySelector('.hp-ph__copy') : previous;
        const incomingCopy = swap ? incoming.querySelector('.hp-ph__copy') : incoming;
        this.animations = [
          outgoingCopy.animate([{ opacity: 1, translate: '0' }, { opacity: 0, translate: `${-direction * 32}px` }], { duration: 320, easing: 'ease-in-out', fill: 'both' }),
          incomingCopy.animate([{ opacity: 0, translate: `${direction * 32}px` }, { opacity: 1, translate: '0' }], { duration: 320, easing: 'ease-in-out', fill: 'both' })
        ];
        if (swap) {
          const outgoingTub = previous.querySelector('.hp-ph__img--main');
          const incomingTub = incoming.querySelector('.hp-ph__img--main');
          if (outgoingTub) this.animations.push(outgoingTub.animate([{ scale: 1 }, { scale: 0 }], { duration: 200, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }));
          if (incomingTub) this.animations.push(incomingTub.animate([{ scale: 0 }, { scale: 1 }], { duration: 300, delay: 200, easing: 'cubic-bezier(0, 0, 0.2, 1)', fill: 'backwards' }));
        }
        await Promise.allSettled(this.animations.map((a) => a.finished));
        if (token !== this.transition) return;
        this.animations.forEach((a) => a.cancel());
        this.paint();
      }
      paint() {
        if (!this.panels.length) return;
        this.dataset.activeCategory = this.panels[this.index].dataset.categoryId;
        this.tabs.forEach((t, i) => { const on = i === this.index; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        this.panels.forEach((p, i) => { p.removeAttribute('data-exiting'); p.hidden = i !== this.index; p.inert = i !== this.index; p.setAttribute('aria-hidden', String(i !== this.index)); });
        this.list.setAttribute('aria-orientation', this.row.matches ? 'horizontal' : 'vertical');
        this.style.setProperty('--hp-ph-progress-at', String((this.index + 1) / this.panels.length));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-qualifiers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-qualifiers')) {
    customElements.define('hp-qualifiers', class extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const options = { signal: this.ac.signal };
        const cards = () => [...this.querySelectorAll('.hp-qualifiers__card')];
        document.addEventListener('shopify:block:select', (e) => {
          const card = e.target.closest('.hp-qualifiers__card');
          if (!card || !this.contains(card)) return;
          card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, options);
        const paint = () => {
          const count = cards().length;
          const range = this.scrollWidth - this.clientWidth;
          this.parentElement.style.setProperty('--hp-q-progress', String(range > 0 ? (1 + (count - 1) * this.scrollLeft / range) / count : 1));
        };
        this.addEventListener('scroll', paint, { passive: true, ...options });
        this.ro = new ResizeObserver(paint);
        this.ro.observe(this);
        paint();
        const prepare = () => {
          this.querySelectorAll('.hp-qualifiers__icon-img').forEach((image) => {
            image.fetchPriority = 'auto';
            image.loading = 'eager';
          });
        };
        if ('IntersectionObserver' in window) {
          this.mediaObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            prepare();
            this.mediaObserver.disconnect();
          }, { rootMargin: '800px 0px' });
          this.mediaObserver.observe(this);
        } else prepare();
      }
      disconnectedCallback() {
        this.ac.abort();
        this.ro?.disconnect();
        this.mediaObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-reviews')) {
    customElements.define('hp-reviews', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.sceneIO?.disconnect();
        this.sceneIO = new IntersectionObserver((entries) => {
          this.toggleAttribute('data-hp-motion-out-of-view', !entries.some((entry) => entry.isIntersecting));
        });
        this.sceneIO.observe(this);
        this.ac = new AbortController();
        const opts = { signal: this.ac.signal };
        const track = this.querySelector('[data-track]');
        const items = [...this.querySelectorAll('[data-review]')];
        const status = this.querySelector('[data-status]');
        let active = items.length > 1 ? 1 : 0;
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        let animations = [];
        let ghosts = [];
        const stop = () => {
          animations.forEach((animation) => animation.cancel());
          animations = [];
          ghosts.forEach((ghost) => ghost.remove());
          ghosts = [];
        };
        const layout = (announce = false) => {
          const mobile = matchMedia('(max-width: 768px)').matches;
          const start = mobile ? active : (active - 1 + items.length) % items.length;
          items.forEach((item, index) => {
            item.style.order = (index - start + items.length) % items.length;
            item.classList.toggle('is-active', index === active);
            item.classList.toggle('is-next', !mobile && Number(item.style.order) === 2);
            item.toggleAttribute('aria-current', index === active);
          });
          if (track) track.scrollLeft = 0;
          if (announce && status) status.textContent = (active + 1) + ' / ' + items.length;
        };
        const move = (step) => {
          if (items.length < 2 || !track) return;
          const before = items.map((item) => item.getBoundingClientRect());
          const orders = items.map((item) => Number(item.style.order));
          stop();
          const bounds = track.getBoundingClientRect();
          // Clone only the outgoing edge card, so a cyclic wrap travels out while its new instance enters.
          const edge = step > 0 ? orders.indexOf(0) : orders.indexOf(items.length - 1);
          if (!reducedMotion.matches && before[edge].left < bounds.right && before[edge].right > bounds.left) {
            const ghost = items[edge].cloneNode(true);
            ghost.removeAttribute('data-review');
            ghost.removeAttribute('aria-current');
            ghost.setAttribute('aria-hidden', 'true');
            ghost.inert = true;
            ghost.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
            Object.assign(ghost.style, { position: 'absolute', left: (before[edge].left - bounds.left) + 'px', top: (before[edge].top - bounds.top) + 'px', width: before[edge].width + 'px', height: before[edge].height + 'px', translate: 'none', margin: '0', pointerEvents: 'none' });
            track.append(ghost);
            ghosts.push(ghost);
          }
          active = (active + step + items.length) % items.length;
          layout(true);
          if (reducedMotion.matches) return;
          const options = { duration: 460, easing: 'cubic-bezier(.22,.68,0,1)' };
          items.forEach((item, index) => {
            const after = item.getBoundingClientRect();
            let x = before[index].left - after.left;
            if (index === edge) x = step > 0 ? Math.max(bounds.right - after.left, after.width) : Math.min(bounds.left - after.right, -after.width);
            const y = before[index].top - after.top;
            animations.push(item.animate([
              { transform: 'translate(' + x + 'px,' + y + 'px) scale(' + before[index].width / after.width + ',' + before[index].height / after.height + ')', transformOrigin: 'top left' },
              { transform: 'translate(0,0) scale(1,1)', transformOrigin: 'top left' }
            ], options));
          });
          ghosts.forEach((ghost) => {
            const animation = ghost.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (-step * (before[edge].width + parseFloat(getComputedStyle(track).gap))) + 'px)' }], options);
            animation.onfinish = () => ghost.remove();
            animations.push(animation);
          });
        };
        layout();
        let trackWidth = track?.clientWidth;
        this.ro = new ResizeObserver(() => {
          if (track?.clientWidth === trackWidth) return;
          trackWidth = track?.clientWidth;
          stop();
          layout();
        });
        if (track) this.ro.observe(track);
        reducedMotion.addEventListener('change', () => { stop(); layout(); }, opts);
        this.ac.signal.addEventListener('abort', stop);
        this.addEventListener('click', (e) => {
          const arrow = e.target.closest('[data-step]');
          if (arrow) move(Number(arrow.dataset.step));
        }, opts);
        track?.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          move(e.key === 'ArrowRight' ? 1 : -1);
        }, opts);
        let start = null;
        track?.addEventListener('pointerdown', (e) => { start = { x: e.clientX, y: e.clientY }; }, opts);
        track?.addEventListener('pointerup', (e) => {
          if (start && Math.abs(e.clientX - start.x) > 40 && Math.abs(e.clientX - start.x) > Math.abs(e.clientY - start.y)) move(e.clientX < start.x ? 1 : -1);
          start = null;
        }, opts);
        track?.addEventListener('pointercancel', () => { start = null; }, opts);
        const io = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.classList.add('is-revealed');
            const speech = this.querySelector('.hp-rv__bubble [data-hp-type]');
            if (speech) window.hpMotion?.type?.(speech, { delay: 750 });
            io.disconnect();
          }
        }, { threshold: 0.15 });
        io.observe(this);
        this.ac.signal.addEventListener('abort', () => io.disconnect());
      }
      disconnectedCallback() { this.ac.abort(); this.ro?.disconnect(); this.sceneIO?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-social-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-social-feed')) {
    customElements.define('hp-social-feed', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.ac = new AbortController();
        this.io?.disconnect();
        this.io = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-out-of-view', !entry.isIntersecting);
        });
        this.io.observe(this);
      }
      disconnectedCallback() { this.ac?.abort(); this.io?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-stockist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-stockist')) {
    customElements.define('hp-stockist', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.io?.disconnect();
        this.sceneIO?.disconnect();
        this.stop?.();
        this.ac = new AbortController();
        const { signal } = this.ac;
        this.sceneIO = new IntersectionObserver((entries) => {
          this.toggleAttribute('data-hp-motion-out-of-view', !entries.some((entry) => entry.isIntersecting));
        });
        this.sceneIO.observe(this);
        const mobilePath = this.querySelector('.hp-stk__curve-mobile textPath');
        if (mobilePath) {
          mobilePath.setAttribute('startOffset', '25.98716316%');
          const trailingGap = mobilePath.lastElementChild;
          if (trailingGap?.classList.contains('hp-curved-title__gap')) trailingGap.remove();
        }
        if (this.hasAttribute('data-hp-curve-travel')) {
          const travel = () => this.querySelectorAll('.hp-curved-title').forEach((heading) => window.hpCurveTravel(this, heading, {
            signal,
            sourceOffset: (mobile) => (mobile ? 25.98716316 : 24.38508368)
          }));
          if (window.hpCurveTravel) travel();
          else document.addEventListener('DOMContentLoaded', travel, { once: true, signal });
        }
        const title = this.querySelector('.hp-curved-title[data-slide]');
        const textPath = title && title.querySelector('textPath');
        if (!textPath) return;
        const path = title.querySelector('path');
        const text = title.querySelector('.hp-curved-title__text');
        if (!path || !text) return;
        const originalRun = [...textPath.childNodes].map((node) => node.cloneNode(true));
        const originalOffset = textPath.getAttribute('startOffset');
        const originalAnchor = text.style.textAnchor;
        const wide = matchMedia('(min-width: 769px)');
        const seconds = parseFloat(getComputedStyle(this).getPropertyValue('--hp-stk-curve-speed')) || 20;
        let unit = 0;
        let offset = 0;
        let origin = 0;
        let last = 0;
        let inView = false;
        let frame = 0;
        const restore = () => {
          if (!unit) return;
          textPath.replaceChildren(...originalRun.map((node) => node.cloneNode(true)));
          textPath.setAttribute('startOffset', originalOffset);
          text.style.textAnchor = originalAnchor;
          unit = 0;
        };
        // Repeated runs share the original run's leading edge so cloning preserves its centre.
        const fill = () => {
          if (unit) return;
          unit = text.getComputedTextLength();
          if (!unit) return;
          const pathLength = path.getTotalLength();
          const copies = Math.ceil(pathLength / unit) + 1;
          for (let i = 0; i < copies; i += 1) originalRun.forEach((node) => textPath.append(node.cloneNode(true)));
          text.style.textAnchor = 'start';
          origin = pathLength * 0.2438508368 - unit / 2;
          offset = origin;
          textPath.setAttribute('startOffset', offset);
        };
        const tick = (now) => {
          frame = 0;
          if (!running()) { last = 0; return; }
          if (!last) last = now;
          offset -= (unit / seconds) * ((now - last) / 1000);
          last = now;
          offset = origin - ((origin - offset) % unit);
          textPath.setAttribute('startOffset', offset);
          if (running()) frame = requestAnimationFrame(tick);
        };
        const running = () => !signal.aborted && this.isConnected && !document.hidden && inView && !window.hpMotion?.paused && wide.matches && !this.querySelector('.hp-editor-block-selected');
        const sync = () => {
          if (signal.aborted || !this.isConnected) return;
          if (running()) {
            if (document.fonts.status === 'loaded') fill();
            if (!frame && unit) frame = requestAnimationFrame(tick);
          } else {
            cancelAnimationFrame(frame);
            frame = 0;
            last = 0;
            if (window.hpMotion?.reduced || !wide.matches) restore();
          }
        };
        document.fonts.ready.then(sync);
        document.addEventListener('hp:motion:change', sync, { signal });
        this.addEventListener('hp:editor:block-select', sync, { signal });
        this.addEventListener('hp:editor:block-deselect', sync, { signal });
        wide.addEventListener('change', sync, { signal });
        document.addEventListener('visibilitychange', sync, { signal });
        this.io = new IntersectionObserver((entries) => { inView = entries.some((entry) => entry.isIntersecting); sync(); }, { threshold: 0.1 });
        this.io.observe(title);
        this.stop = () => {
          cancelAnimationFrame(frame);
          frame = 0;
          last = 0;
          restore();
        };
      }
      disconnectedCallback() {
        this.sceneIO?.disconnect();
        this.ac?.abort();
        this.io?.disconnect();
        this.stop?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-timeline')) {
    customElements.define('hp-timeline', class extends HTMLElement {
      connectedCallback() {
        this.ac = new AbortController();
        const paint = () => {
          const range = this.scrollWidth - this.clientWidth;
          const count = this.children.length;
          this.parentElement.style.setProperty('--hp-tl-progress-at', String(range > 0 ? (1 + (count - 1) * this.scrollLeft / range) / count : 1));
          if (matchMedia('(min-width: 769px)').matches) {
            [...this.children].forEach((slot) => {
              const connector = slot.querySelector('.hp-timeline__connector');
              const next = slot.nextElementSibling?.querySelector('.hp-timeline__icon-img');
              if (connector && next) connector.style.setProperty('--hp-tl-link-width', `${Math.max(15, next.getBoundingClientRect().left - connector.getBoundingClientRect().left - 3.238)}px`);
            });
          }
        };
        this.addEventListener('scroll', paint, { passive: true, signal: this.ac.signal });
        this.ro = new ResizeObserver(paint);
        this.ro.observe(this);
        this.querySelectorAll('img').forEach((image) => image.addEventListener('load', paint, { signal: this.ac.signal }));
        paint();
      }
      disconnectedCallback() { this.ac.abort(); this.ro?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product"] && !Shopify.designMode) return;
  try {
    
  if (!window.__sneakRevealInit) {
    window.__sneakRevealInit = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-reveal-toggle]');
      if (!btn) return;
      var wrapper = btn.closest('[data-reveal]');
      var revealText = wrapper.querySelector('.product__reveal-text');
      var original = wrapper.previousElementSibling;

      if (original && original.classList.contains('product__short-description')) {
        original.hidden = true;
      }
      btn.hidden = true;
      btn.setAttribute('aria-expanded', 'true');
      revealText.hidden = false;
      revealText.focus({ preventScroll: true });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sneak-announcement"] && !Shopify.designMode) return;
  try {
    
/* Publish the global headline-size settings as CSS vars on <html> so every section reads them (survives the theme's Vue re-render) */
(function(){
  if(window.__sneakHeadBound)return;window.__sneakHeadBound=1;
  function apply(){
    var el=document.querySelector('.sneak-anc[data-head-d]');if(!el)return;
    var r=document.documentElement.style;
    var d=el.getAttribute('data-head-d'),m=el.getAttribute('data-head-m'),hd=el.getAttribute('data-hero-d'),hm=el.getAttribute('data-hero-m');
    if(d)r.setProperty('--sneak-head-d',d+'px');
    if(m)r.setProperty('--sneak-head-m',m+'px');
    if(hd)r.setProperty('--sneak-hero-d',hd+'px');
    if(hm)r.setProperty('--sneak-hero-m',hm+'px');
  }
  apply();
  if(window.MutationObserver){var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(apply,120);}).observe(document.body,{childList:true,subtree:true});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sneak-faq"] && !Shopify.designMode) return;
  try {
    
/* Document-level delegation: survives the theme's Vue re-render of section DOM */
(function(){
  if(window.__sneakFaqBound)return;window.__sneakFaqBound=1;
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.sneak-faq__q');if(!btn)return;
    var root=btn.closest('.sneak-faq');if(!root)return;
    var open=btn.getAttribute('aria-expanded')==='true';
    root.querySelectorAll('.sneak-faq__q').forEach(function(b){
      b.setAttribute('aria-expanded','false');
      var p=b.parentElement.querySelector('.sneak-faq__a');if(p)p.hidden=true;
      var ic=b.querySelector('.sneak-faq__icon');if(ic)ic.textContent='+';
    });
    if(!open){
      btn.setAttribute('aria-expanded','true');
      var pan=btn.parentElement.querySelector('.sneak-faq__a');if(pan)pan.hidden=false;
      var icon=btn.querySelector('.sneak-faq__icon');if(icon)icon.textContent='−';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sneak-hero"] && !Shopify.designMode) return;
  try {
    
/* Document-level delegation + state map + re-apply: survives the theme's Vue re-render of section DOM */
(function(){
  if(window.__sneakHeroBound)return;window.__sneakHeroBound=1;
  /* Add to cart via AJAX, then open the theme's slide cart instead of going to the /cart page */
  function openSlideCart(){
    try{['cart:refresh','cart:updated','cart:build'].forEach(function(n){document.dispatchEvent(new CustomEvent(n,{bubbles:true,detail:{}}));});}catch(_){}
    var bag=document.querySelector('svg[viewBox="0 0 19 21"]');bag=bag?bag.closest('button'):null;
    if(!bag){var bs=[].slice.call(document.querySelectorAll('button')).filter(function(b){var r=b.getBoundingClientRect();return r.top<160&&r.width>0&&b.querySelector('svg');});bs.sort(function(a,b){return b.getBoundingClientRect().right-a.getBoundingClientRect().right;});bag=bs[0];}
    if(bag){bag.click();return true;}
    return false;
  }
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form.hero__atc');if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('.hero__buy');if(btn)btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json();})
      .then(function(){ if(!openSlideCart()){window.location.href='/cart';} })
      .catch(function(){ window.location.href='/cart'; })
      .finally(function(){ if(btn)btn.disabled=false; });
  });
  var VISIBLE=5;
  var state={};
  function key(root){return root.id||'hero';}
  function st(root){var k=key(root);if(!state[k])state[k]={active:0,start:0};return state[k];}
  function slides(root){return [].slice.call(root.querySelectorAll('.hero__slide'));}
  function thumbs(root){return [].slice.call(root.querySelectorAll('.hero__thumb'));}
  function total(root){return parseInt(root.dataset.total,10)||slides(root).length||0;}
  function pad(n){return (n<10?'0':'')+n;}
  function setDisplay(el,show){var v=show?'':'none';if(el.style.display!==v)el.style.display=v;}
  function setText(el,t){if(el&&el.textContent!==t)el.textContent=t;}
  function render(root){
    var s=st(root),t=total(root),sl=slides(root),th=thumbs(root);
    if(s.active>=t)s.active=t?t-1:0;if(s.active<0)s.active=0;
    sl.forEach(function(x,i){x.classList.toggle('is-active',i===s.active);});
    th.forEach(function(x,i){x.classList.toggle('is-active',i===s.active);});
    var c=root.querySelector('[data-hero-count]');if(c)setText(c,pad(s.active+1)+' / '+pad(t));
    var win=root.querySelector('[data-hero-window]');
    if(win){var max=Math.max(0,t-VISIBLE);if(s.start>max)s.start=max;if(s.start<0)s.start=0;
      th.forEach(function(x,i){setDisplay(x,i>=s.start&&i<s.start+VISIBLE);});}
  }
  function go(root,i,dir){
    var s=st(root),t=total(root);if(t<1)return;s.active=((i%t)+t)%t;
    var win=root.querySelector('[data-hero-window]');
    if(win){var max=Math.max(0,t-VISIBLE);
      if(dir==='fwd')s.start=Math.max(s.start,Math.min(s.active,max));
      else if(dir==='back')s.start=Math.min(s.start,Math.max(s.active-(VISIBLE-1),0));
      if(s.active<s.start)s.start=s.active;if(s.active>s.start+VISIBLE-1)s.start=s.active-VISIBLE+1;}
    render(root);
  }
  function ordinal(n){var a=['th','st','nd','rd'],v=n%100;return n+(a[(v-20)%10]||a[v]||a[0]);}
  var dateFull,dateShort;
  (function(){
    var days=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var daysS=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months=['January','February','March','April','May','June','July','August','September','October','November','December'];
    var monthsS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var d=new Date();
    if(d.getHours()>=16)d.setDate(d.getDate()+1);
    d.setDate(d.getDate()+1);
    while(d.getDay()===0||d.getDay()===6)d.setDate(d.getDate()+1);
    dateFull=days[d.getDay()]+' '+ordinal(d.getDate())+' '+months[d.getMonth()];
    dateShort=daysS[d.getDay()]+' '+ordinal(d.getDate())+' '+monthsS[d.getMonth()];
  })();
  function applyDate(root){setText(root.querySelector('[data-deliv-d]'),dateFull);setText(root.querySelector('[data-deliv-m]'),dateShort);}
  function initAll(){document.querySelectorAll('.sneak-hero').forEach(function(root){render(root);applyDate(root);});}
  document.addEventListener('click',function(e){
    var el,root;
    if((el=e.target.closest('[data-hero-next]'))){root=el.closest('.sneak-hero');if(root)go(root,st(root).active+1,'fwd');return;}
    if((el=e.target.closest('[data-hero-prev]'))){root=el.closest('.sneak-hero');if(root)go(root,st(root).active-1,'back');return;}
    if((el=e.target.closest('[data-thumb]'))){root=el.closest('.sneak-hero');if(root){var i=parseInt(el.getAttribute('data-thumb'),10)||0;go(root,i,i>=st(root).active?'fwd':'back');}return;}
    if((el=e.target.closest('[data-hero-tnext]'))){root=el.closest('.sneak-hero');if(root){var s=st(root);s.start=Math.min(s.start+1,Math.max(0,total(root)-VISIBLE));render(root);}return;}
    if((el=e.target.closest('[data-hero-tprev]'))){root=el.closest('.sneak-hero');if(root){var s2=st(root);s2.start=Math.max(s2.start-1,0);render(root);}return;}
    var btn=e.target.closest('.hero__faq-q');
    if(btn){var acc=btn.closest('[data-hero-acc]');if(!acc)return;var open=btn.getAttribute('aria-expanded')==='true';
      acc.querySelectorAll('.hero__faq-q').forEach(function(b){b.setAttribute('aria-expanded','false');var p=b.parentElement.querySelector('.hero__faq-a');if(p)p.hidden=true;var ic=b.querySelector('.hero__faq-icon');if(ic)ic.textContent='+';});
      if(!open){btn.setAttribute('aria-expanded','true');var pan=btn.parentElement.querySelector('.hero__faq-a');if(pan)pan.hidden=false;var icon=btn.querySelector('.hero__faq-icon');if(icon)icon.textContent='−';}
    }
  });
  var x0=null,swRoot=null;
  document.addEventListener('touchstart',function(e){var stg=e.target.closest('[data-hero-stage]');if(!stg)return;swRoot=stg.closest('.sneak-hero');x0=e.changedTouches[0].clientX;},{passive:true});
  document.addEventListener('touchend',function(e){if(x0===null||!swRoot)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){if(dx<0)go(swRoot,st(swRoot).active+1,'fwd');else go(swRoot,st(swRoot).active-1,'back');}x0=null;swRoot=null;});
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(initAll);setTimeout(initAll,300);setTimeout(initAll,1200);
  if(window.MutationObserver){var to;new MutationObserver(function(){clearTimeout(to);to=setTimeout(initAll,120);}).observe(document.body,{childList:true,subtree:true});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sneak-reviews"] && !Shopify.designMode) return;
  try {
    
/* Document-level delegation + re-apply: survives the theme's Vue re-render of section DOM */
(function(){
  if(window.__sneakRevBound)return;window.__sneakRevBound=1;
  function track(root){return root.querySelector('[data-rev-track]');}
  function cards(root){var t=track(root);return t?[].slice.call(t.querySelectorAll('.sneak-rev__card')):[];}
  function shown(root){return cards(root).filter(function(c){return !c.hidden;});}
  function step(root){var t=track(root);var v=shown(root)[0];if(!v)return t?t.clientWidth:0;var g=parseFloat(getComputedStyle(t).columnGap||getComputedStyle(t).gap||0)||0;return v.getBoundingClientRect().width+g;}
  function per(root){var t=track(root);var s=step(root);return s?Math.max(1,Math.round(t.clientWidth/s)):1;}
  function buildDots(root){
    var dotsWrap=root.querySelector('[data-rev-dots]');if(!dotsWrap)return;
    var v=shown(root);var p=per(root);var pages=Math.max(1,Math.ceil(v.length/p));
    if(pages<=1){dotsWrap.innerHTML='';return;}
    var html='';for(var i=0;i<pages;i++){html+='<button type="button" class="sneak-rev__dot'+(i===0?' is-active':'')+'" data-rev-dot="'+i+'"></button>';}
    dotsWrap.innerHTML=html;
  }
  function applyFilter(root){
    var active=root.querySelector('.sneak-rev__tab.is-active');
    var tab=active?active.getAttribute('data-rev-tab'):null;
    if(!tab)return;
    var changed=false;
    cards(root).forEach(function(c){var h=(c.getAttribute('data-rev-of')!==tab);if(c.hidden!==h){c.hidden=h;changed=true;}});
    if(changed||!root.querySelector('[data-rev-dots]').children.length)buildDots(root);
  }
  function initAll(){document.querySelectorAll('.sneak-rev').forEach(function(root){applyFilter(root);});}
  document.addEventListener('click',function(e){
    var tab=e.target.closest('[data-rev-tab]');
    if(tab){var r=tab.closest('.sneak-rev');r.querySelectorAll('.sneak-rev__tab').forEach(function(b){b.classList.remove('is-active');});tab.classList.add('is-active');var t=track(r);if(t)t.scrollLeft=0;applyFilter(r);return;}
    var nx=e.target.closest('[data-rev-next]');if(nx){var rn=nx.closest('.sneak-rev');track(rn).scrollBy({left:step(rn),behavior:'smooth'});return;}
    var pv=e.target.closest('[data-rev-prev]');if(pv){var rp=pv.closest('.sneak-rev');track(rp).scrollBy({left:-step(rp),behavior:'smooth'});return;}
    var dot=e.target.closest('[data-rev-dot]');if(dot){var rd=dot.closest('.sneak-rev');var i=parseInt(dot.getAttribute('data-rev-dot'),10)||0;track(rd).scrollTo({left:i*per(rd)*step(rd),behavior:'smooth'});return;}
  });
  document.addEventListener('scroll',function(e){
    var t=e.target;if(!t||!t.getAttribute||t.getAttribute('data-rev-track')===null)return;
    var root=t.closest('.sneak-rev');if(!root)return;var dotsWrap=root.querySelector('[data-rev-dots]');var d=dotsWrap?[].slice.call(dotsWrap.children):[];if(!d.length)return;
    var s=step(root);var p=per(root);var idx=s?Math.round(t.scrollLeft/(p*s)):0;d.forEach(function(x,i){x.classList.toggle('is-active',i===idx);});
  },true);
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(initAll);
  if(window.MutationObserver){var to;new MutationObserver(function(){clearTimeout(to);to=setTimeout(initAll,120);}).observe(document.body,{childList:true,subtree:true});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sneak-switch"] && !Shopify.designMode) return;
  try {
    
/* Document-level delegation: survives the theme's Vue re-render of section DOM */
(function(){
  if(window.__sneakSwBound)return;window.__sneakSwBound=1;
  function step(track){var c=track.querySelector('.sneak-sw__card');if(!c)return track.clientWidth;var g=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap||0)||0;return c.getBoundingClientRect().width+g;}
  document.addEventListener('click',function(e){
    var next=e.target.closest('[data-sneak-next]');
    var prev=e.target.closest('[data-sneak-prev]');
    if(!next&&!prev)return;
    var root=(next||prev).closest('.sneak-sw');if(!root)return;
    var track=root.querySelector('[data-sneak-track]');if(!track)return;
    track.scrollBy({left:next?step(track):-step(track),behavior:'smooth'});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
